var map = {
	"./amboss_px.png": 3348,
	"./arrow.gif": 6849,
	"./arschkarte_px.png": 5904,
	"./axt_px.png": 8561,
	"./dolmar_px.png": 1756,
	"./efdab_px.png": 6952,
	"./flask.png": 3231,
	"./katana_px.png": 6809,
	"./landkarte_px.png": 5930,
	"./manabar_px.png": 6411,
	"./messer_px.png": 2272,
	"./opfer_tatort_px.png": 832,
	"./polaroid_px.png": 4550,
	"./schlaeger_px.png": 6692,
	"./schlauch_comb_px.png": 5032,
	"./schlauch_px.png": 3861,
	"./schluessel_px.png": 7672,
	"./speisekarte_px.png": 6488,
	"./taucherbrille_px.png": 2400,
	"./toefflibueb_px.png": 7713,
	"./tuerklinke_px.png": 1520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6410;